import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import './HelmetVerification.css';

/**
 * Reads current document head (title + meta) and shows them in a panel.
 * Visible when URL has ?helmet=1 so you can verify react-helmet-async is working.
 * Example: /login?helmet=1 or /privacy-policy?helmet=1
 */
const HelmetVerification = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [headState, setHeadState] = useState({ title: '', description: '', ogTitle: '', collapsed: true });

  const showPanel = searchParams.get('helmet') === '1';

  useEffect(() => {
    if (!showPanel) return;
    // Let Helmet update the DOM first (next tick)
    const t = setTimeout(() => {
      const title = document.title || '(empty)';
      const descMeta = document.querySelector('meta[name="description"]');
      const description = (descMeta && descMeta.getAttribute('content')) || '(not set)';
      const ogTitleMeta = document.querySelector('meta[property="og:title"]');
      const ogTitle = (ogTitleMeta && ogTitleMeta.getAttribute('content')) || '(not set)';
      setHeadState(prev => ({ ...prev, title, description, ogTitle }));
    }, 100);
    return () => clearTimeout(t);
  }, [showPanel, location.pathname, location.key]);

  if (!showPanel) return null;

  return (
    <div className="helmet-verification" aria-label="Helmet verification panel">
      <button
        type="button"
        className="helmet-verification-toggle"
        onClick={() => setHeadState(prev => ({ ...prev, collapsed: !prev.collapsed }))}
      >
        {headState.collapsed ? 'Show Helmet check' : 'Hide Helmet check'} (react-helmet-async)
      </button>
      {!headState.collapsed && (
        <div className="helmet-verification-panel">
          <div className="helmet-verification-row">
            <strong>document.title</strong>
            <span className="helmet-verification-value" title={headState.title}>{headState.title}</span>
          </div>
          <div className="helmet-verification-row">
            <strong>meta name="description"</strong>
            <span className="helmet-verification-value" title={headState.description}>{headState.description}</span>
          </div>
          <div className="helmet-verification-row">
            <strong>meta property="og:title"</strong>
            <span className="helmet-verification-value" title={headState.ogTitle}>{headState.ogTitle}</span>
          </div>
          <p className="helmet-verification-hint">Navigate to another page (with ?helmet=1) to see values update.</p>
        </div>
      )}
    </div>
  );
};

export default HelmetVerification;
